module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/elvis.png?567bac7e3d1f27e08d2af197bc62b0f3";